import type { T_ChatV8InsightWidgetData } from "@lattice/core-lib/types/chat-v8";

/**
 * Historical presentation intent is explicit, not inferred from topic.
 * Current authoring no longer emits prose-only portfolio-fit widgets
 * (RAI-1100); this branch remains so immutable RAI-1080 threads still render.
 */
export function isChatV8NarrativeInsight(
  data: Pick<T_ChatV8InsightWidgetData, "descriptor" | "insightKind">,
): boolean {
  return (
    data.insightKind === "portfolio_fit" &&
    data.descriptor.presentationKind === "narrative"
  );
}
